module.exports = __webpack_public_path__ + "static/media/AcceptButton.afda5b6f.svg";